import { Menu } from '@headlessui/react'
import IonIcon from '@reacticons/ionicons'
import cn from 'classnames'
//import Link from 'next/link'
import React, {
  useEffect,
  useState,
  //useState
} from 'react'
import { LabelLink } from 'src/components/global/LabelLink'
import { INSIGHTS_MENU } from 'src/constants/constants'
//import * as enVariables from 'src/config/config'

//import styles from './Header.module.scss'

/**
 * Primary UI component for user interaction
 */
const lthInsightsMenu = INSIGHTS_MENU

const FirstComponent = ({ menuOpen, setMenu }: { menuOpen: boolean; setMenu: any }) => {
  //const [open, setOpen] = useState(menuOpen)

  const handleMenuItemClick = () => {
    setMenu(!menuOpen)
  }
  return (
    menuOpen && (
      <Menu.Items
        static
        className="z-[9999] flex flex-row w-full  rounded-[10px] shadow-lg bg-white absolute"
        style={{ top: '40px', width: 'auto' }}
      >
        <div className="py-2 w-full">
          <ul>
            {lthInsightsMenu &&
              lthInsightsMenu.map((item: any, index: number) => {
                return (
                  <li className="px-2 w-full" key={'insights' + index}>
                    <LabelLink
                      key={'insights-' + index}
                      href={item?.slg}
                      label={item?.title}
                      target={item?.target}
                      className="font-secondary font-medium text-[0.875rem] text-left px-3 leading-9 block w-full items-center h-full text-textdark bg-white rounded-[10px] hover:bg-turquoise hover:bg-opacity-10"
                      onClick={handleMenuItemClick}
                    />
                  </li>
                )
              })}
          </ul>
        </div>
      </Menu.Items>
    )
  )
}

interface MenuProps {
  isOpen: boolean
}
export const InsightsMenu: React.FC<MenuProps> = ({ isOpen }) => {
  const [menuOpen, setMenuOpen] = useState(isOpen)

  useEffect(() => {
    setMenuOpen(isOpen)
  }, [isOpen])

  const setMenu = (status: any) => {
    setMenuOpen(status)
  }

  return (
    <Menu as="div" className={cn('relative inline-block h-full text-nowrap cursor-pointer text-left')}>
      {({ open }) => (
        <>
          <Menu.Button
            type="button"
            className={cn(
              'inline-flex justify-center gap-1 items-center w-full text-white font-secondary text-[0.875rem] h-full font-bold',
              { 'bg-white bg-opacity-5': open },
            )}
            onClick={() => setMenuOpen(!menuOpen)}
          >
            Insights
            <IonIcon
              className="text-white mr-0 !important"
              name={menuOpen ? 'chevron-up-outline' : 'chevron-down-outline'}
            />
          </Menu.Button>
          <FirstComponent menuOpen={menuOpen} setMenu={setMenu} />
          {/* {open && (
            <Transition
              as={Fragment}
              enter="transition ease-out duration-100"
              enterFrom="transform opacity-0 scale-95"
              enterTo="transform opacity-100 scale-100"
              leave="transition ease-in duration-75"
              leaveFrom="transform opacity-100 scale-100"
              leaveTo="transform opacity-0 scale-95"
            >
              <Menu.Items
                static
                className="z-30 overflow-hidden flex flex-row w-[295px] h-[17.1rem] rounded-[1.25rem] shadow-lg bg-white absolute"
                style={{ top: '60px' }}
              >
                <div className="absolute py-4 w-[295px] h-full">
                  <ul>
                    {lthInsightsMenu &&
                      lthInsightsMenu.map((item: any, index: number) => {
                        return (
                          <li className="px-3 h-10 w-full" key={'insights' + index}>
                            <LabelLink
                              key={'insights-' + index}
                              href={item?.slg}
                              label={item?.title}
                              className="font-secondary font-medium text-[0.875rem] text-left px-6 w-full inline-flex items-center h-full text-textdark bg-white rounded-[10px] hover:bg-turquoise hover:bg-opacity-10"
                            />
                          </li>
                        )
                      })}
                  </ul>
                </div>
              </Menu.Items>
            </Transition>
          )} */}
        </>
      )}
    </Menu>
  )
}
